import { useEffect, useMemo, useState } from 'react';

import { ProductKeys } from '@atlassiansox/asc-stargate';

import { useProductTemplateContext } from '@/components/product-template-context-provider';
import { useSiteSelectorContext } from '@/components/site-selector-modal/site-selector-context';

import JiraSoftwareNav from './software-jira-navbar';

const JiraSoftwareNavUniform = () => {
	const { template } = useProductTemplateContext();
	const { openModalForTemplate } = useSiteSelectorContext();
	const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = useState(false);

	const openModalForTemplateClickAction = useMemo(() => {
		return (event: React.MouseEvent<HTMLButtonElement>) => {
			event.preventDefault();
			event.stopPropagation();
			openModalForTemplate({
				templateId: template?.templateId as string,
				templateName: template?.templateName as string,
				productKey: template?.productKey as ProductKeys,
			});
		};
	}, [openModalForTemplate, template?.templateId, template?.templateName, template?.productKey]);

	useEffect(() => {
		if (template?.templateId && template?.templateName && template?.productKey) {
			setIsUseOpenCrossFlow(true);
		}
	}, [template?.templateId, template?.templateName, template?.productKey]);

	return (
		<JiraSoftwareNav
			productNavCtaCTAClickFunction={openModalForTemplateClickAction}
			isUseOpenCrossFlow={isUseOpenCrossFlow}
		/>
	);
};

JiraSoftwareNavUniform.displayName = 'JiraSoftwareNavUniform';

export default JiraSoftwareNavUniform;
